import React from "react";

import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import ChartXLBasePage from "./ChartXLBasePage";
import rootReducer from "../reducers";

const DEBUG = false && __DEBUG__;

function getFinalStore() {
	let finalCreateStore;
	if (DEBUG) {
		const { devTools, persistState } = require("redux-devtools");
		finalCreateStore = compose(
			applyMiddleware(thunk),
			devTools(),
			persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
		)(createStore);
	} else {
		finalCreateStore = applyMiddleware(thunk)(createStore);
	}

	return finalCreateStore(rootReducer);
}

const store = getFinalStore();

if (module.hot) {
	module.hot.accept("../reducers", () => {
		const nextReducer = require("../reducers");
		store.replaceReducer(nextReducer);
	});
}

export default class App extends React.Component {
	render() {
		let debug = null;
		if (DEBUG) {
			const { DevTools, DebugPanel, LogMonitor } = require("redux-devtools/lib/react");
			debug = (<DebugPanel top bottom right>
				<DevTools store={store} monitor={LogMonitor} />
			</DebugPanel>);
		}

		return (
			<div>
				<Provider store={store}>
					<ChartXLBasePage />
				</Provider>
				{debug}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/scripts/containers/App.js
 **/